/**
 * RESPONSIBILITY: the Children's page team grid.
 */
import type { ChildrenTeamSection } from '@app/sections';
import { PersonCard } from '../commons/PersonCard';

export function ChildrenTeam({ c }: { c: ChildrenTeamSection }) {
  const team = c.team ?? [];
  return (
    <section className="band">
      <div className="wrap">
        <div className="band-head"><h2>{c.teamHeading}</h2></div>
        <div className="grid grid-3">
          {team.map((p, i) => <PersonCard key={i} p={p} />)}
        </div>
      </div>
    </section>
  );
}
